export const scrollToElement = (element?: Element | null) => {
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
